import { useEffect } from 'react';
import {
    Navigate,
    useNavigate,
    useParams,
    useSearchParams,
} from 'react-router-dom';

import { PriorAuthorizationDetails } from '../../components/prior-authorization/PriorAuthorizationDetails';
import { getFragment } from '../../graphql';
import { GetPriorAuthorizationDocument } from '../../graphql/generated/graphql';
import { useFlags } from '../../hooks/use-flags';
import { QueryLoader } from '../../loaders';
import { getAbsoluteRoute } from '../../util';

const NonDrxPriorAuthorizationOrderDetailsRoute = () => {
    const { priorAuthorizationId } = useParams();
    const { nonDrxPriorAuthorizationEnabled } = useFlags();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const contextParam = searchParams.get('context');

    if (!nonDrxPriorAuthorizationEnabled)
        return <Navigate to={getAbsoluteRoute('home')} />;

    const Loader = QueryLoader<typeof GetPriorAuthorizationDocument>;

    if (!priorAuthorizationId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    // SMS context reroute logic
    // oxlint-disable-next-line react-hooks/rules-of-hooks -- tracked in docs/oxlint-violations.md
    useEffect(() => {
        if (!contextParam) return;
        navigate(
            getAbsoluteRoute('priorAuthorization.priorAuthorizationId.status', {
                priorAuthorizationId,
            })
        );
    }, [contextParam, priorAuthorizationId, navigate]);

    return (
        <Loader
            query={GetPriorAuthorizationDocument}
            variables={{ priorAuthorizationId }}
            queryOptions={{ errorPolicy: 'all' }}
            render={(data) => {
                const priorAuthInfo = getFragment(data.priorAuthorization);
                if (!priorAuthInfo) {
                    return <Navigate to={getAbsoluteRoute('error')} />;
                }

                return (
                    <PriorAuthorizationDetails
                        priorAuthorization={priorAuthInfo}
                    />
                );
            }}
        />
    );
};

export default NonDrxPriorAuthorizationOrderDetailsRoute;
